import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/judo';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-248" data-mp="30xq5pe6uukus">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-249" data-mp="2w56swjfzrtr1">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-250" data-mp="2r7wu4d6pq5qj">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-251" data-mp="2r5kcy28s3zej">
            Czy znasz to z własnego doświadczenia?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-252" data-mp="2i5xe9o7fp7p6">
            Jeśli odpowiesz „tak” choć na jedno pytanie, JUDO GOTOWE™ jest dla Ciebie.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-253" data-mp="289kk6p7z8rtw">
            Zasługujesz na prostsze rozwiązanie
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-254" data-mp="6hz1m622ball" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-255" data-mp="3nnqgvhkqgkqt">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-256" data-mp="3elqxwjq5r6l8">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-257" data-mp="3eo3fuwvx1gya">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-258" data-mp="b5s6q3zyecn4" />
                </span>
                <div data-id="element-259" data-mp="3sm1pjozakp7g">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-260" data-mp="3smjurb3xmdri">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-261" data-mp="1ep6t5irg3pf">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}